import { InputButton } from "@arcade-hockey/shared";

export type KeyBinding = {
  move: { up: string; down: string; left: string; right: string };
  sprint: string;
  buttons: Partial<Record<InputButton, string>>;
};

export const defaultKeyBinding: KeyBinding = {
  move: { up: "KeyW", down: "KeyS", left: "KeyA", right: "KeyD" },
  sprint: "ShiftLeft",
  buttons: {
    [InputButton.Pass]: "KeyJ",
    [InputButton.Shoot]: "KeyK",
    [InputButton.Poke]: "KeyL",
    [InputButton.StickLift]: "Semicolon",
    [InputButton.Context]: "KeyU",
    [InputButton.BigHit]: "KeyI",
    [InputButton.Goalie]: "ControlLeft",
    [InputButton.LineSelect1]: "Digit1",
    [InputButton.LineSelect2]: "Digit2",
    [InputButton.LineSelect3]: "Digit3",
    [InputButton.LineSelect4]: "Digit4",
    [InputButton.StrategyDefensive]: "ArrowLeft",
    [InputButton.StrategyOffensive]: "ArrowRight",
    [InputButton.GoaliePullToggle]: "KeyG",
    [InputButton.Pause]: "KeyP",
  },
};

export type GamepadBinding = {
  sprintTriggerIndex: number;
  buttons: Partial<Record<InputButton, number>>;
  axes: { moveX: number; moveY: number };
};

export const defaultGamepadBinding: GamepadBinding = {
  sprintTriggerIndex: 7,
  buttons: {
    [InputButton.Pass]: 0,
    [InputButton.Shoot]: 1,
    [InputButton.Poke]: 2,
    [InputButton.StickLift]: 3,
    [InputButton.Context]: 4,
    [InputButton.BigHit]: 5,
    [InputButton.Goalie]: 6,
    [InputButton.LineCycleUp]: 12,
    [InputButton.LineCycleDown]: 13,
    [InputButton.StrategyDefensive]: 14,
    [InputButton.StrategyOffensive]: 15,
    [InputButton.GoaliePullToggle]: 8,
    [InputButton.Pause]: 9,
  },
  axes: { moveX: 0, moveY: 1 },
};

export const STICK_DEADZONE = 0.15;
